export const isBrowser = () => typeof window !== 'undefined';

export const isTextSelection = () => {
  const selection = isBrowser() && window.getSelection();
  return selection && selection.toString();
};
